module.exports = __webpack_public_path__ + "img/brackets_left_layout_icon.0e796b6b.svg";